<style lang="less">
.invoice-list {
  .title {
    width: 100px;
    text-align: right;
    padding: 12px 12px 12px 0
  }
  .item {
    position: relative;
    border: 1px dashed #bebebe;
    margin: 0 20px 20px 20px;
    padding: 40px 20px 0px 0px;
    .delete {
      position: absolute;
      right: 10px;
      top: 10px
    }
  }
}
.invoice-list-add {
  display: flex;
  justify-content: center;
  .ivu-form-item-content {
    margin-left: 0!important
  }
}
</style>
<template>
  <div class="invoice-generate-container">
    <Form
      :model="bill"
      :label-width="100"
    >
      <FormItem label="Bill Company">
        <BillCompanySelector v-model="bill.bill_company" />
      </FormItem>
      <FormItem label="Bill To">
        <BillToSelector v-model="bill.send_company" />
      </FormItem>
      <FormItem label="Invoice Uid">
        <i-input v-model="bill.uid" />
      </FormItem>
      <FormItem label="Amount Unit">
        <Select v-model="bill.price_unit">
          <Option :value="0">
            $-USD-美元
          </Option>
          <Option :value="1">
            €-EUR-欧元
          </Option>
          <Option :value="4">
            £-GBP-英镑
          </Option>
          <Option :value="5">
            ¥-RMB-人民币
          </Option>
          <Option :value="2">
            C$-CAD-加拿大元
          </Option>
          <Option :value="3">
            A$-AUD-澳大利亚元
          </Option>
        </Select>
      </FormItem>
      <FormItem label="Date">
        <DatePicker
          size="small"
          :value="bill.date"
          @on-change="function(date){itemDateChange(bill, 'date', date)}"
        />
      </FormItem>
      <div class="invoice-list">
        <div class="title">
          Bill List
        </div>
        <Form
          v-for="(item, index) in bill.items"
          :key="item.id"
          class="item"
          :label-width="100"
        >
          <FormItem label="Marks&No.">
            <i-input v-model="item.no" />
          </FormItem>
          <FormItem label="Description">
            <i-input v-model="item.desc" />
          </FormItem>
          <FormItem label="Amount">
            <i-input v-model="item.amount" />
          </FormItem>
          <Button
            size="small"
            class="delete"
            type="error"
            shape="circle"
            icon="ios-close"
            @click="handleRemove(item, index)"
          />
        </Form>
      </div>
      <FormItem class="invoice-list-add">
        <Button
          style="width: 200px"
          @click="handleAdd"
        >
          Add Bill List
        </Button>
      </FormItem>
      <FormItem>
        <Button
          type="primary"
          @click="handlePrint"
        >
          生成发票
        </Button>
      </FormItem>
    </Form>
    <InvoicePrint
      ref="invoice_print"
      :bill="bill"
      @generated="queryRecentGenerateInvoiceNumber"
    />
  </div>
</template>
<script route="/invoice/generate">
  import InvoicePrint from './components/invoice_print.vue'
  import BillCompanySelector from './components/bill_company_selector.vue'
  import BillToSelector from './components/bill_to_selector.vue'
  export default {
    /* router_info_start */
    router_info: '/invoice/generate',
    components: {
      InvoicePrint,
      BillCompanySelector,
      BillToSelector
    },
    /* router_info_end */

    data() {
      return {
        recent_invoice_number: 0,
        bill: {
          bill_company: 'FIVERR INTERNATIONAL LTD',
          send_company: 'CHENGDU CHAOYOUAI TECHNOLOGY CO.，LTD',
          uid: '',
          price_unit: 0,
          date: new Date().getFullYear() + '-' + (new Date().getMonth() + 1).toString().padStart(2, 0) + '-' + new Date().getDate().toString().padStart(2, 0),
          items: [
            {
              no: 1,
              desc: 'Production Service Fee',
              amount: 0
            }
          ],
        }
      }
    },
    created() {
      this.queryRecentGenerateInvoiceNumber()
    },
    methods: {
      queryRecentGenerateInvoiceNumber() {
        this.$util.ajax.get(this.$util.api.query_recent_generate_invoice_number).then(data => {
          this.recent_invoice_number = data.data.data
          const toDay = new Date()
          const dayString = toDay.getFullYear() + (toDay.getMonth() + 1).toString().padStart(3, 0) + toDay.getDate().toString().padStart(2, 0)
          this.bill.uid = '#' + dayString + (this.recent_invoice_number + 1).toString().padStart(3, 0)
        })
      },
      itemDateChange(item, key, date) {
        item[key] = date
      },
      handleAdd() {
        this.bill.items.push({
          no: this.bill.items.length + 1,
          desc: 'Production Service Fee',
          amount: 0
        })
      },
      handleRemove(item, index) {
        this.bill.items.splice(index, 1)
      },
      handlePrint() {
        this.$refs['invoice_print'].print(this.bill)
      }
    }
  }
</script>
